import cx from 'classnames';
import PropTypes from 'prop-types';
import Container from '@/container';
import {forwardRef} from 'react';

import styles from './styles.module.scss';

const propTypes = {children: PropTypes.node.isRequired, onClose: PropTypes.func};

const AdBanner = forwardRef(({children, onClose}, ref) => (
  <div className={cx(styles['ad-banner'], 'ad-banner')} ref={ref} data-testid="ad-banner">
    <Container>
      <div className={styles['ad-banner__inner']}>
        {children}
        {onClose && (
          <button
            type="button"
            className={styles['ad-banner__close']}
            onClick={onClose}
            aria-label="Close banner"
            data-testid="ad-banner-close"
          />
        )}
      </div>
    </Container>
  </div>
));

AdBanner.propTypes = propTypes;

export default AdBanner;
